import gql from 'graphql-tag';

const RequestAccountCreate = gql(/* GraphQL */ `
  mutation RequestAccountCreate($input: RequestAccountCreateInput!) {
    requestAccountCreate(input: $input) {
      phone
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default RequestAccountCreate;
